if (document.readyState !== 'loading') {
    initWidget();
} else {
    window.addEventListener('DOMContentLoaded', () => {
        initWidget();
    });
}

function initWidget() {
    if (!window.Swiper) {
        return;
    }

    const sliders = document.querySelectorAll('.ct_testimonials');

    if (sliders) {
        sliders.forEach((slider) => {
            const sliderContainer = slider.querySelector('.swiper-container');

            if (!sliderContainer) {
                return;
            }

            const swiperConfig = {
                speed: 1250,
                keyboard: true,
                slidesPerView: 'auto',
                loop: true,
                autoHeight: false,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: true,
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.button-next',
                    prevEl: '.button-prev',
                },
            };

            if (window.lazyLoadInstance) {
                // set swiperConfig.on to an empty object if it is not defined yet
                swiperConfig.on = swiperConfig.on || {};
                // update our lazyload instance on swiper init event
                swiperConfig.on.init = () => {
                    window.lazyLoadInstance.update();
                };
            }

            // init swiper (swiper is available in the global scope)
            const swiper = new Swiper(sliderContainer, swiperConfig);

            swiper.autoplay.start();
        });
    }
}
